import MENU_SPC from './menu_specialist';
import MENU_SA from './menu'
import MENU_MD from './menu_moderator'
import MENU_TA from './menu_techassistanse'
import MENU_ADM from './menu_admin';



export const config = {
    roles: ['kindergartenHead', 'moderator', 'admin', 'nurse', 'kindergartenHeadPrivate', 'techassistance', 'superadmin', 'specialist'],
    rolesName_old: ['Директор комунального садочка', 'Модератор району', 'Адміністратор', 'Медична сестра', 'Директор приватного садочка', 'Працівник технічної підтримки', 'Адміністратор(с)'],
    rolesName:["Керівник ЗДО", "Модератор", "Адміністратор", "Медична сестра","Директор приватного садочка", "Технічна підтримка", "Адміністратор системи", "Спеціаліст ДОН"],
    districts: ["Голосіївський", "Дарницький", "Деснянський", "Дніпровський", "Оболонський", "Печерський", "Подільський", "Святошинський", "Солом’янський", "Шевченківський"],
    authType: {
        'none': 'Не визначена',
        'phone': 'моб.тлф.',
        'eds': 'КЕП',
        'email': 'е-Пошта',
        'nbubankid': 'BankID НБУ'
    },
    specificsKindergarten: [
        'Загального розвитку', 'Комбінований', 'Санаторний', 'Спеціальний'
    ],
    workingHoursType: ['Повний день', '12', '10.5', '11', '5', '14', 'Цілодобово', 'Короткотривала'],

    cabinetMenu:{
        'superadmin': MENU_SA,
        'admin': MENU_ADM,
        'moderator': MENU_MD,
        'techassistance': MENU_TA,
        'specialist': MENU_SPC
    }
    
}